// @flow
import React, { useContext } from 'react';
import nest from 'recompose/nest';

import { Highlight, HighlightHeader } from 'app/common/layouts/commonShop';
import { Dipper } from 'app/common/markup';
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';

import ShippingMethodsApi, { ShippingMethods, type ShippingMethod } from 'app/common/components/Shop/ShippingMethodsApi';
import nope from 'app/common/lib/nope';


type Props = {
  className?: string
}

const DeliveryHighlight = ({ className }: Props) => {
  const { content: { data } } = useContext(ShippingMethods);

  return (
    <Highlight className={className}>
      <HighlightHeader>
        {'Доставка'}
      </HighlightHeader>
      {data.map(({ id, name, shipping_cost: cost }: ShippingMethod) => (
        <p key={id}>
          <b>{`${name}:`}</b>
          {` от ${toFixedValueCurrency(cost)}`}
        </p>
      ))}
      <p>
        <Dipper>
          <a href="/" onClick={nope}>{'Подробнее об условиях доставки'}</a>
        </Dipper>
      </p>
    </Highlight>
  );
};

export default nest(ShippingMethodsApi, DeliveryHighlight);
